import { PersonMenuItemKey } from '../../constants/personMenuItemKeys';
import { USER_DIALOG_ACTION_TYPES } from '../../constants/userDialog.constants';
import { v4 as uuid } from 'uuid';

export const showAddEditPerson = ({
  personId = null,
  requestId = uuid(),
  closeOnSave = false,
  origin = null,
  initialMenuKey = PersonMenuItemKey.PERSON_DETAILS,
} = {}) => ({
  type: USER_DIALOG_ACTION_TYPES.SHOW_ADD_EDIT_PERSON,
  payload: { personId, requestId, closeOnSave, origin, initialMenuKey },
});

export const hideAddEditPerson = (requestId = null) => ({
  type: USER_DIALOG_ACTION_TYPES.HIDE_ADD_EDIT_PERSON,
  payload: { requestId },
});

export const personSaved = (person, { isEditMode = false, requestId = null } = {}) => ({
  type: USER_DIALOG_ACTION_TYPES.PERSON_SAVED,
  payload: { person, isEditMode, requestId },
});
